import * as Sentry from '@sentry/nextjs';
import { ROUTES_PATH } from 'constants/routeConfig';
import { useAppDispatch } from 'hooks/toolkit';
import { useRouter } from 'next/router';
import { setUserSessionExpired } from 'store/slices/user';
import { MapAny } from 'types';

export const usePostLogin = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handlePostLogin = ({ userId, is_cash_ops_enabled }: MapAny) => {
    if (is_cash_ops_enabled && process.env.NEXT_PUBLIC_CASH_OPS_HOST) {
      window.location.replace(process.env.NEXT_PUBLIC_CASH_OPS_HOST);

      return;
    }

    if (userId) {
      Sentry.setUser({ id: userId });
      dispatch(setUserSessionExpired(false));
      router.push(ROUTES_PATH.HOME);
    }
  };

  return handlePostLogin;
};
